import React from 'react';

const CartFooter = ({
  children,
  shouldRenderFooter = true,
}: {
  children: React.ReactNode;
  shouldRenderFooter?: boolean;
}) => {
  if (!shouldRenderFooter) return null;
  return (
    <div className="flex flex-none flex-shrink-0 flex-col px-1 pb-1">
      {children}
    </div>
  );
};

export default CartFooter;
